
import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <div className="footer">
      <a 
        href="https://www.linkedin.com/in/biruk-kiros-meles-68aaa7214/" 
        target="_blank" 
        rel="noopener noreferrer"
        className="linkedin-link"
      >
        <div className="linkedin-container">
          <span className="collab-text">Contact me for collaboration</span>
          <div className="linkedin-logo">in</div>
          
        </div>
      </a>
    </div>
  );
}